export const pharmacyRegisterActions = {
  REGISTER_PHARMACY: {
    REQUEST: 'registration/registerPharmacyRequest',
    SUCCESS: 'registration/registerPharmacySuccess',
    FAILURE: 'registration/registerPharmacyFailure',
    RESET: 'registration/registerPharmacyReset'
  }
};
